import React, { createContext, useContext, useMemo, useState } from 'react';

export type Session = {
	customerId: string | null;
	businessId: string | null;
	emailVerified: boolean;
};

type SessionContextType = {
	session: Session | null;
	setSession: (s: Session | null) => void;
};

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export function SessionProvider({ children }: { children: React.ReactNode }) {
	const [session, setSession] = useState<Session | null>(null);
	const value = useMemo(() => ({ session, setSession }), [session]);
	return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
	const ctx = useContext(SessionContext);
	if (!ctx) throw new Error('useSession must be used within SessionProvider');
	return ctx;
} 